import { Flex, Spinner, Text, VStack } from '@chakra-ui/react';
import { Logo } from '@fluenceur/ui';
import { useTranslation } from 'react-i18next';

/**
 * Minimal callback page for the Chrome Extension auth flow.
 *
 * The extension's `chrome.tabs.onUpdated` listener watches for this URL
 * and reads the `?code=` query parameter before closing the tab.
 * No additional client-side logic is needed here.
 */
export default function ExtensionCallbackPage() {
  const { t } = useTranslation();

  return (
    <Flex minH="100vh" align="center" justify="center" bg="babyPowder">
      <VStack gap={6}>
        <Logo h="28px" />
        <Spinner size="lg" color="gray.500" />
        <Text color="fg.muted" fontSize="sm">
          {t('extension.connectingMessage')}
        </Text>
      </VStack>
    </Flex>
  );
}
